export default __webpack_public_path__ + "static/media/WorkSans-Regular.21eab2a7.woff2";